import { TFunction } from 'i18next';
import * as yup from 'yup';
import { EMPTY_STRING, MAX_FILE_SIZE } from '~/utils/constants/common';
import { IBaseFile } from '~/utils/interface/common';
import { IPaymentQuote } from '~/utils/interface/quotes';

export const schema = (t: TFunction): yup.ObjectSchema<IPaymentQuote> =>
  yup.object({
    businessId: yup.string().optional(),
    businessType: yup.string().optional(),
    paymentMethod: yup.string().required(t('common_validate_field_required', { ns: 'common/base' })),
    amountType: yup.string().required(t('common_validate_field_required', { ns: 'common/base' })),
    amount: yup
      .string()
      .when('amountType', {
        is: (val: string) => val === 'Other Amount',
        then: (schema) => schema.required(t('common_validate_field_required', { ns: 'common/base' })),
        otherwise: (schema) => schema.optional(),
      })
      .optional(),
    cardNumber: yup.string().optional(),
    cardExp: yup.string().optional(),
    cvc: yup.string().optional(),
    paymentDate: yup.string().optional(),
    note: yup.string().optional(),
    dataDescriptor: yup.string().optional(),
    dataValue: yup.string().optional(),
  });

export const defaultValues: IPaymentQuote = {
  paymentMethod: 'Cash',
  amountType: EMPTY_STRING,
};
